function LanguageIcon({ size = '12', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M5.97151 8.16345L4.59568 6.80386L4.61193 6.78761C5.55443 5.73678 6.2261 4.52886 6.62151 3.25053H8.2086V2.1672H4.41693V1.08386H3.3336V2.1672H-0.458069V3.24511H5.59235C5.22943 4.29053 4.65526 5.28178 3.87526 6.14845C3.37151 5.59053 2.95443 4.97845 2.62401 4.33386H1.54068C1.9361 5.21678 2.47776 6.05095 3.15485 6.80386L0.397765 9.52303L1.16693 10.2922L3.87526 7.58386L5.55985 9.26845L5.97151 8.16345ZM9.0211 5.4172H7.93777L5.50026 11.9172H6.5836L7.19026 10.2922H9.76318L10.3753 11.9172H11.4586L9.0211 5.4172ZM7.60193 9.20886L8.47943 6.86345L9.35693 9.20886H7.60193Z"
          fill="#959FAF"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default LanguageIcon;
